import preferences from "@coworker/enums/profilePreferences";
import { useUserPreference } from "../../hooks/useProfilePreferencesQuery";
import { getShellLanguage } from "../shellLanguage";

/**
 * Shared locale accessor for the app.
 *
 * When the Flexa shell provides a language via `ShellContext.language` (the
 * embedded/MFE case) it is the source of truth and wins over the backend user
 * preference — mirroring what `LanguageSetter` feeds into i18n. Falls back to
 * the backend `LANGUAGE` preference when running standalone (no shell language).
 *
 * Routing every locale consumer (`useFormatter`, the SIK search hooks, etc.)
 * through this accessor keeps translations, date/number formatting and search
 * behavior aligned with the language the shell actually renders in.
 */
export function useLanguage(): string {
  const [userLanguage] = useUserPreference(preferences.LANGUAGE, "");
  return getShellLanguage() ?? userLanguage;
}
